import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../../../components';

const VisibilityCellRenderer = ({ value }) =>
  value ? null : <Icon name='check' displaySize={16} color='var(--primary-default)' />;

VisibilityCellRenderer.propTypes = {
  value: PropTypes.bool.isRequired
};

export { VisibilityCellRenderer };
